import { createStore } from 'vuex'

export default createStore({
  state: { // 存储
    username: '',
    ucode: '',
    token: '',
    transAnData: [],
    transAnTitle: '',
    libraryData: {},
    libraryText: '',
    uploadImage: null,
    libraryGood: {}
  },
  mutations: { // 修改
    setuser (state, user) {
      state.username = user.user
      state.ucode = user.ucode
      state.token = user.token
      localStorage.setItem('user', user.user)
      localStorage.setItem('ucode', user.ucode)
      // 只保存合法 token
      const token = user.token
      if (token && token !== 'null' && token !== 'undefined' && token.trim() !== '') {
        localStorage.setItem('token', token)
      } else {
        console.error('setuser: 拒绝保存无效token', token)
        localStorage.removeItem('token')
      }   
    },
    settoken (state, user) {
      state.token = user.token
      localStorage.setItem('token', user.token)
    },
    deluser (state, user) {
      state.username = user.user
      state.ucode = user.ucode
      state.token = user.token
      localStorage.removeItem('user')
      localStorage.removeItem('ucode')
      localStorage.removeItem('token') 
    },
    deltoken (state) {
      state.token = ''
      localStorage.removeItem('token')
    },
    setTransAnData (state, list) {
      state.transAnData = list
    },
    setTransAnTitle (state, titlestr) {
      state.transAnTitle = titlestr
    },
    setLibraryGood (state, n) {
      state.libraryGood = n
    },
    setLibraryData (state, list) {
      state.libraryData = list
    },
    setLibraryText (state, text) {
      state.libraryText = text
    },
    setUploadImage(state, image) {
      state.uploadImage = image
    }
  }
})

